import React from 'react';
import {
  Box,
  Typography,
  CircularProgress,
  Button
} from '@mui/material';
import { Add as AddIcon, TaskAlt as TaskIcon } from '@mui/icons-material';
import TaskGrid from './TaskGrid';
import TasksTable from './TasksTable';
import { useTranslation } from 'react-i18next';

// Tasks.tsx'ten gelen styled componentları kullanacak şekilde props olarak alacağız
interface TasksNormalViewProps {
  loading: boolean;
  filteredTasks: any[];
  statusFilter: string;
  viewMode: 'card' | 'list';
  onShowTaskDetail: (task: any) => void;
  onOpenQrPrintModal: (task: any, event: React.MouseEvent) => void;
  getStatusColor: (status: string) => string;
  getStatusIcon: (status: string) => React.ReactNode;
  getStatusLabel: (status: string) => string;
  getTaskTimeColor: (task: any, timeString: string) => string;
  companyId: string | null;
  onOpenDeviceModal: (deviceInfo: any) => void;
  setAddTaskModalOpen: (open: boolean) => void;
  LoadingContainer: React.ComponentType<any>;
  NoDataBox: React.ComponentType<any>;
  branches: {[key: string]: string}; // Şube bilgilerini içeren prop
  onRenewTask?: (taskId: string, adminNote: string) => Promise<void>; // Görevi yenileme fonksiyonu
}

const TasksNormalView: React.FC<TasksNormalViewProps> = ({
  loading,
  filteredTasks,
  statusFilter,
  viewMode,
  onShowTaskDetail,
  onOpenQrPrintModal,
  getStatusColor,
  getStatusIcon,
  getStatusLabel,
  getTaskTimeColor,
  companyId,
  onOpenDeviceModal,
  setAddTaskModalOpen,
  LoadingContainer,
  NoDataBox,
  branches,
  onRenewTask
}) => {
  const { t } = useTranslation('common2');
  
  // Sadece tekrarlamayan görevleri filtrele
  const normalTasks = filteredTasks.filter(task => !task.isRecurring);

  if (loading) {
    return (
      <LoadingContainer>
        <CircularProgress />
      </LoadingContainer>
    );
  }

  if (normalTasks.length === 0) {
    return (
      <NoDataBox>
        <TaskIcon sx={{ fontSize: 60, color: 'grey.400', mb: 1 }} />
        <Typography color="textSecondary">
          {t('tasks.noData.title')}
        </Typography>
        <Typography variant="body2" color="textSecondary" sx={{ mt: 1 }}>
          {t('tasks.noData.description')}
        </Typography>
        <Button
          variant="contained"
          color="primary"
          startIcon={<AddIcon />}
          onClick={() => setAddTaskModalOpen(true)}
          sx={{ mt: 2 }}
        >
          {t('tasks.noData.addTask')}
        </Button>
      </NoDataBox>
    );
  }

  return viewMode === 'card' ? (
    <Box sx={{ mb: 3 }}>
      <TaskGrid
        tasks={normalTasks}
        onShowTaskDetail={onShowTaskDetail}
        onOpenQrPrintModal={onOpenQrPrintModal}
        getStatusColor={getStatusColor}
        getStatusIcon={getStatusIcon}
        getStatusLabel={getStatusLabel}
        getTaskTimeColor={getTaskTimeColor}
        onOpenDeviceModal={onOpenDeviceModal}
        taskType="normal"
        branches={branches}
        onRenewTask={onRenewTask}
      />
    </Box>
  ) : (
    <Box sx={{ mb: 3 }}>
      <TasksTable
        tasks={normalTasks}
        statusFilter={statusFilter}
        onShowTaskDetail={onShowTaskDetail}
        onOpenQrPrintModal={onOpenQrPrintModal}
        getStatusColor={getStatusColor}
        getStatusIcon={getStatusIcon}
        getStatusLabel={getStatusLabel}
        getTaskTimeColor={getTaskTimeColor}
        companyId={companyId}
        onOpenDeviceModal={onOpenDeviceModal}
        taskType="normal"
        branches={branches}
        onRenewTask={onRenewTask}
      />
    </Box>
  );
};

export default TasksNormalView; 